module.exports = __webpack_public_path__ + "img/user_guide.c671f7cb.png";